const consentBarChartTransformer = (data, source, defaultData) => {
  return data.reduce((acc, current) => {
    if (current.os == "ios" && current.media_consent && current.data_consent) {
      acc.series[0].data[0] += current[source]
    } else if (current.os == "ios" && current.media_consent && !current.data_consent) {
      acc.series[1].data[0] += current[source]
    } else if (current.os == "ios" && !current.media_consent && current.data_consent) {
      acc.series[2].data[0] += current[source]
    } else if (current.os == "ios" && !current.media_consent && !current.data_consent) {
      acc.series[3].data[0] += current[source]
    } else if (current.os == "android" && current.media_consent && current.data_consent) {
      acc.series[0].data[1] += current[source]
    } else if (current.os == "android" && current.media_consent && !current.data_consent) {
      acc.series[1].data[1] += current[source]
    } else if (current.os == "android" && !current.media_consent && current.data_consent) {
      acc.series[2].data[1] += current[source]
    } else if (current.os == "android" && !current.media_consent && !current.data_consent) {
      acc.series[3].data[1] += current[source]
    }
    return acc
  }, {...defaultData} )
}

export default consentBarChartTransformer